import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';

import axios from 'axios';
// @mui
import {
  Card,
  Table,
  Stack,
  Grid,
  Paper,
  Avatar,
  Button,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
} from '@mui/material';
// components
import Label from '../components/label';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';
import Loader from './loader/Loader';
// mock
// import USERLISTA from '../_mock/user';
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'Name', label: 'Name', alignRight: false },
  { id: 'Username', label: 'Username', alignRight: false },
  { id: 'Mobile No', label: 'Mobile No', alignRight: false },
  { id: 'Email', label: 'Email', alignRight: false },

  { id: 'Block', label: 'Block', alignRight: false },
  { id: 'Gp', label: 'Gp', alignRight: false },
  { id: 'Action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function UserPage() {
  const navigate = useNavigate();
  // console.log(USERLISTA);
  const [USERLIST, setuserlist] = useState([]);
  const [useredit, setuseredit] = useState('');
  const [userdelete, setuserdelete] = useState('');
  const [isLoader, setIsLoader] = useState(true);

  // const [codevalue, setcodeValue] = useState([]);
  useEffect(() => {
    fetchuser();
  }, []);
  const fetchuser = () => {
    axios
      .post(
        'http://drdc.rtcsindia.co.in/api/userList',
        {},
        {
          headers: {
            Authorization: localStorage.getItem('id_token'),
            'content-type': 'application/json',
          },
        }
      )
      .then((response) => {
        setuserlist(response.data.userlist);
        setIsLoader(false);
        // console.log(response.data.userlist);
        // console.log(USERLIST);
      })
      .catch((err) => {
        console.log(err);
        setIsLoader(false);
      });
  };
  const getuseredit = () => {
    axios
      .post(
        'http://drdc.rtcsindia.co.in/api/user_edit',
        { code: useredit },
        {
          headers: {
            Authorization: localStorage.getItem('id_token'),
            'content-type': 'application/json',
          },
        }
      )
      .then((response) => {
        setuseredit(response.data.options);
        navigate('/dashboard/user', { state: response.data.options });
        // console.log(response.data.userlist);
        // console.log(USERLIST);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getuserdelete = () => {
    axios
      .post(
        'http://drdc.rtcsindia.co.in/api/user_delete',
        { code: userdelete },
        {
          headers: {
            Authorization: localStorage.getItem('id_token'),
            'content-type': 'application/json',
          },
        }
      )
      .then((response) => {
        fetchuser();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setuseredit(event.currentTarget.value);
    setuserdelete(event.currentTarget.value);
  };
  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);
  // console.log('filter', filteredUsers);

  const isNotFound = !filteredUsers.length && !!filterName;

  return (
    <>
      {isLoader ? (
        <Loader />
      ) : (
        <>
          <Helmet>
            <title> User | Minimal UI </title>
          </Helmet>

          <Container className="userlist-table">
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
              <Grid container spacing={4} className="user-form" style={{ padding: '2%' }}>
                <Grid item xs={2}>
                  <Typography variant="h4" gutterBottom>
                    User List
                  </Typography>
                </Grid>
                <Grid item xs={8} />
                <Grid item xs={2}>
                  <NavLink to="/dashboard/user" style={{ textDecoration: 'none' }}>
                    <Button variant="contained">Create User</Button>
                  </NavLink>
                </Grid>
              </Grid>
            </Stack>

            <Card>
              <UserListToolbar
                numSelected={selected.length}
                filterName={filterName}
                onFilterName={handleFilterByName}
              />

              <Scrollbar>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table>
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEAD}
                      rowCount={USERLIST.length}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                    />
                    <TableBody>
                      {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                        const { code, name, username, mobileno, email, blockname, gpname, usercode } = row;
                        const selectedUser = selected.indexOf(name) !== -1;

                        return (
                          <TableRow hover key={code} tabIndex={-1} role="checkbox" selected={selectedUser}>
                            <TableCell padding="checkbox">
                              <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, name)} />
                            </TableCell>
                            <TableCell component="th" scope="row" padding="none">
                              <Stack direction="row" alignItems="center" spacing={2}>
                                {/* <Avatar alt={name} src={avatarUrl} /> */}
                                <Typography variant="subtitle2" noWrap>
                                  {name}
                                </Typography>
                              </Stack>
                            </TableCell>
                            <TableCell align="left">{username}</TableCell>
                            <TableCell align="left">{mobileno}</TableCell>
                            <TableCell align="left">{email}</TableCell>
                            <TableCell align="left">{blockname}</TableCell>
                            <TableCell align="left">{gpname}</TableCell>

                            {/* <TableCell align="left">{isVerified ? 'Yes' : 'No'}</TableCell>
                        <TableCell align="left">
                          <Label color={(status === 'banned' && 'error') || 'success'}>{sentenceCase(status)}</Label>
                        </TableCell> */}
                            <TableCell align="right">
                              <IconButton size="large" color="inherit" onClick={handleOpenMenu} value={usercode}>
                                <Iconify icon={'eva:more-vertical-fill'} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>

                    {isNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <Paper
                              sx={{
                                textAlign: 'center',
                              }}
                            >
                              <Typography variant="h6" paragraph>
                                Not found
                              </Typography>

                              <Typography variant="body2">
                                No results found for &nbsp;
                                <strong>&quot;{filterName}&quot;</strong>.
                                <br />
                                Try checking for typos or using complete words.
                              </Typography>
                            </Paper>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100, { value: -1, label: 'all' }]}
                component="div"
                count={USERLIST.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Card>
          </Container>

          <Popover
            open={Boolean(open)}
            anchorEl={open}
            onClose={handleCloseMenu}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                p: 1,
                width: 140,
                '& .MuiMenuItem-root': {
                  px: 1,
                  typography: 'body2',
                  borderRadius: 0.75,
                },
              },
            }}
          >
            <MenuItem onClick={getuseredit}>
              <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
              Edit
            </MenuItem>

            <MenuItem onClick={getuserdelete} sx={{ color: 'error.main' }}>
              <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
              Delete
            </MenuItem>
          </Popover>
        </>
      )}
    </>
  );
}
